import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["minHeight"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { minHeightComponentStyles } from './styled';
export var MinHeightContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var minHeight = _ref.minHeight,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    ref: ref
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: minHeightComponentStyles
  }, props, {
    style: _defineProperty({}, '--link-picker-min-height', minHeight)
  }));
});